import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/competition/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/competition/';

class CompetitionService {

  getPredictions(competitionId){
    return axios.get(`${API_URL}${competitionId}/predictions`);
  }

  getAll() {
    return axios.get(API_URL );
  }

  postCompetition(competition) {
    return axios.post(API_URL,competition );
  }

}

export default new CompetitionService();



// WEBPACK FOOTER //
// ./src/services/competition.service.js